export default () => ({
  billingData: {
    isLoading: true,
    hasError: false,
    paymentHash: null,
    tourists: [],
    bookings: {},
    details: {
      amount: 0,
      clientEmail: null,
      clientId: null,
      clientPhone: null,
      commission: null,
      orderId: null,
      serviceName: null
    }
  },
  methodSelectForm: {
    isLoading: false,
    isActive: false,
    hasError: false,
    orderId: null,
    sum: null,
    paymentSuppliers: [],
    cardCommission: null
  },
  invoiceForm: {
    isActive: false,
    supplierCode: null
  },
  isFormLoading: false,
  billingForm: {
    isLoading: false,
    formData: {
      amount: 0,
      name: null,
      email: null
    }
  },
  billingFormErrors: []
})